import React, {useEffect, useState} from 'react'
import Chart from 'react-apexcharts'
import {Col, Row, Spinner, Stack} from 'react-bootstrap'
import { chartOptions } from '../../../utils/helper'

interface Props {
  data?: any
  heading: any
  subheading: any
  reload : boolean
}

function DonutPieChart({data, heading, subheading, reload }: Props) {
  const [utilSeries, setUtilSeries] = useState<any>([])
  const [total, setTotal] = useState<number>(0)
  const [colors, setColors] = useState<any>([])
  const [labels, setLabels] = useState<any>([])
  const [utilityMixData, setUtilityMixData] = useState<any>([])
  
  const statusOrder = [
    'NO_TPV',
    'PASSED',
    'INCOMPLETE',
    'FAILED',
    'PENDING',
    'UNVERIFIED'
  ];
  const statusColorMap: Record<string, string> = {
    'NO_TPV': '#F6C000',
    'PASSED': '#50CD89',
    'INCOMPLETE': '#f64505',
    'FAILED': '#f30606',
    'PENDING': '#0866f1',
    'UNVERIFIED': '#a95aa9'
  };

  useEffect(() => {
    if (data?.tpvStatus?.length) {
      const statusCountMap: Record<string, any> = {};
      data?.tpvStatus?.forEach((item: any) => {
        statusCountMap[item?.tpvStatusType] = item;
      });

      // Build arrays in fixed order
      const labels = statusOrder;
      const series = statusOrder?.map(status => statusCountMap[status]?.tpvStatusCount || 0);
      const colors = statusOrder?.map(status => statusColorMap[status]);
      const utilityMixData = statusOrder?.map(status => ({
        tpvStatusType: formatLabel(status),
        tpvStatusCount: statusCountMap[status]?.tpvStatusCount || 0,
        color: statusColorMap[status]
      }));
      setLabels(labels?.map((val)=>( formatLabel(val))));
      setUtilSeries(series);
      setColors(colors);
      setUtilityMixData(utilityMixData);
      setTotal(data?.totalTpvs || 0);
    }
  }, [data]);

  const formatLabel = (label: string): string => {
    const acronyms = ['TPV'];
    return label
      .split('_')
      .map((word, index) => {
        const upperWord = word?.toUpperCase();
        if (acronyms.includes(upperWord)) return upperWord;
        const lower = word?.toLowerCase();
        return index === 0 ? lower.charAt(0).toUpperCase() + lower.slice(1) : lower;
      })
      .join(' ');
  };
  

  const options: Object = chartOptions(labels, colors);

  

  return (
    <div className='card card-flush card-border mb-5 mb-xl-10 h-auto'  style={{minHeight:'365px'}}>
      <Stack gap={2} className='container mt-8 mb-5 ms-4'>
        <div className='text-dark fw-bolder fs-3'>{heading}</div>
        <Stack direction='horizontal' gap={2}>
          <div className='fw-bold fs-6 text-dark'>{total}</div>
          <div className='text-muted fs-6'>{subheading}</div>
        </Stack>
      </Stack>
      {reload ? (
        <div className="text-center mb-20">
          <Spinner animation="border" className="text-gray-600 text-center" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
      </div>) : (
      <div className='container'>
        <Row className='align-items-center'>
          <Col sm md lg='6'>
            <div className='position-relative d-flex flex-center mb-7'>
              <Chart
                type='donut'
                width={300}
                height={270}
                series={utilSeries || []}
                options={options}
                className='d-block'
              />
            </div>
          </Col>
          <Col sm md lg='6'>
            <Row>
              <Col lg md sm='6'>
                {utilityMixData?.slice(0, Math.floor(utilityMixData.length / 2)).map((item: any) => {
                  return (
                      <div
                        className='d-flex me-15 cap mb-8'
                        key={item.tpvStatusType}
                      >
                        <span
                          className='bullet bullet-dot h-10px w-10px me-3 mt-2'
                          style={{backgroundColor: `${item?.color}`}}
                        />
                        <Stack>
                          <span className='fw-bold fs-2'>
                            {item?.tpvStatusCount}
                          </span>
                          <span className='fs-6' style={{color: `${item?.color}`, textTransform:"capitalize"}}>
                            {item?.tpvStatusType}
                          </span>
                        </Stack>
                      </div>
                  )
                })}

              </Col>
              <Col lg md sm="6">
              {utilityMixData?.slice(Math.floor(utilityMixData.length / 2)).map((item: any) => {
                return (
                    <div className='d-flex me-15 cap mb-8' key={item.tpvStatusType}>
                      <span
                        className='bullet bullet-dot h-10px w-10px me-3 mt-2'
                        style={{backgroundColor: `${item?.color}`}}
                      ></span>
                      <Stack>
                        <span className='fw-bold fs-2'>{item?.tpvStatusCount}</span>
                        <span className='fs-6' style={{color: `${item?.color} `,textTransform:"capitalize"}}>
                          {item?.tpvStatusType}
                        </span>
                      </Stack>
                    </div>
                )
              })}
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      )}
    </div>
  )
}

export default DonutPieChart
